import { render, staticRenderFns } from "./MonthView.vue?vue&type=template&id=647134f2&scoped=true"
import script from "./MonthView.vue?vue&type=script&lang=js"
export * from "./MonthView.vue?vue&type=script&lang=js"
import style0 from "./MonthView.vue?vue&type=style&index=0&id=647134f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647134f2",
  null
  
)

export default component.exports